import { defineMessage } from '@lingui/macro';

const BLOCK_TYPE_TITLE_ACCESS = 'BLOCK_TYPE_TITLE_ACCESS',
  BLOCK_TYPE_TITLE_INFORMATION = 'BLOCK_TYPE_TITLE_INFORMATION',
  BLOCK_TYPE_TITLE_INTERFERENCE = 'BLOCK_TYPE_TITLE_INTERFERENCE',
  BLOCK_TYPE_TITLE_MATERIAL = 'BLOCK_TYPE_TITLE_MATERIAL',
  BLOCK_TYPE_TITLE_EQUIPMENT_TOOLS = 'BLOCK_TYPE_TITLE_EQUIPMENT_TOOLS';

export const BlockTypeMessages = {
  [BLOCK_TYPE_TITLE_ACCESS]: defineMessage({ message: `Access` }),
  [BLOCK_TYPE_TITLE_INFORMATION]: defineMessage({ message: `Information` }),
  [BLOCK_TYPE_TITLE_INTERFERENCE]: defineMessage({ message: `Interference` }),
  [BLOCK_TYPE_TITLE_MATERIAL]: defineMessage({ message: `Material` }),
  [BLOCK_TYPE_TITLE_EQUIPMENT_TOOLS]: defineMessage({ message: `Equipment/Tools` }),
};

const BLOCK_TYPE_DESCRIPTION_ACCESS = 'BLOCK_TYPE_DESCRIPTION_ACCESS',
  BLOCK_TYPE_DESCRIPTION_EQUIPMENT_TOOLS = 'BLOCK_TYPE_DESCRIPTION_EQUIPMENT_TOOLS',
  BLOCK_TYPE_DESCRIPTION_INFORMATION = 'BLOCK_TYPE_DESCRIPTION_INFORMATION',
  BLOCK_TYPE_DESCRIPTION_INTERFERENCE = 'BLOCK_TYPE_DESCRIPTION_INTERFERENCE',
  BLOCK_TYPE_DESCRIPTION_MATERIAL = 'BLOCK_TYPE_DESCRIPTION_MATERIAL';

export const BlockTypeDescriptionMessages = {
  [BLOCK_TYPE_DESCRIPTION_ACCESS]: defineMessage({
    message: `Access blocked (equipment, barracade, or scaffold)`,
  }),
  [BLOCK_TYPE_DESCRIPTION_EQUIPMENT_TOOLS]: defineMessage({
    message: `Construction tools (eg. crane, tool etc.)`,
  }),
  [BLOCK_TYPE_DESCRIPTION_INFORMATION]: defineMessage({
    message: `More information needed to proceed (survey, etc.)`,
  }),
  [BLOCK_TYPE_DESCRIPTION_INTERFERENCE]: defineMessage({
    message: `Design or field issue preventing installation`,
  }),
  [BLOCK_TYPE_DESCRIPTION_MATERIAL]: defineMessage({
    message: `Missing or incorrect material`,
  }),
};
